import React, { useCallback, useMemo, useState, useEffect } from "react";
import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";
import Table, { ColumnsType } from "antd/lib/table";
import { parseISO } from "date-fns";
import { HistoryOutlined } from "@ant-design/icons";
import { useAuth } from "../../../hooks/auth";
import UserRoles from "../../../enums/UserRoles";
import { IhistoryConfig } from "../index";
import { IUser } from "../../User";
import api from "../../../services/api";
import UserAvatar from "../../../components/UserAvatar";

interface IFieldValueHistoryModalProps {
  configData: IhistoryConfig[];
  title: string;
}

interface INewHistory extends IhistoryConfig {
  newValue: number;
}

const FieldValueHistoryModal: React.FC<IFieldValueHistoryModalProps> = ({
  configData,
  title,
}) => {
  const { t } = useTranslation(["config"]);
  const { user } = useAuth();
  const [handleVisibleHistory, setHandleVisibleHistory] = useState(false);
  const [modifyUser, setModifyUser] = useState<string[]>([]);
  const [modificatoryAvatar, setModificatoryAvatar] = useState<
    {
      name: string;
      avatar: string | null;
      id: string;
    }[]
  >([]);

  const modifyConfig = useMemo(() => {
    const users_m: string[] = [];
    configData.map((cfg) => {
      users_m.push(cfg.m_user_id);
      return cfg;
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    setModifyUser([...new Set(users_m)]);
    return [...configData].reverse();
  }, [handleVisibleHistory]);

  const isLoggedUserManager = useMemo(
    () =>
      user.role === UserRoles.Manager || user.role === UserRoles.Administrative,
    [user.role]
  );

  useEffect(() => {
    if (modifyUser) {
      modifyUser.map(async (m_user) => {
        api.get<IUser>(`/users/${m_user}`).then((res) => {
          setModificatoryAvatar((mdf) => [
            ...mdf,
            {
              avatar: res.data.avatar,
              name: res.data.name,
              id: res.data.id,
            },
          ]);
        });
        return m_user;
      });
    }
  }, [modifyUser, handleVisibleHistory]);

  function getAvatar(user_id: string) {
    return modificatoryAvatar.filter((m) => m.id === user_id)[0]?.name || "";
  }

  function getName(user_id: string) {
    return modificatoryAvatar.filter((m) => m.id === user_id)[0]?.avatar || "";
  }

  const handleClose = useCallback(() => {
    setHandleVisibleHistory(false);
  }, []);

  const actionsHistoryColumns: ColumnsType<IhistoryConfig> = [
    {
      title: t("config.m_value"),
      dataIndex: "m_value",
    },
    {
      title: t("config.m_user_id"),
      dataIndex: "m_user_id",
      render: (user_id) => {
        return (
          (
            <UserAvatar
              name={getAvatar(user_id)}
              url={getName(user_id)}
              size={36}
            />
          ) || ""
        );
      },
    },
    {
      title: t("config.create_at"),
      dataIndex: "create_at",
      render: (date) =>
        date &&
        `${parseISO(date).toLocaleDateString("pt-BR")} às ${parseISO(
          date
        ).toLocaleTimeString("pt-BR")}`,
    },
  ];

  return isLoggedUserManager ? (
    <>
      <Modal
        title={`${title}`}
        destroyOnClose
        visible={handleVisibleHistory}
        width={800}
        onCancel={() => handleClose()}
        getContainer={false}
        footer={[
          <Button type="primary" key="ok" onClick={() => handleClose()}>
            Ok
          </Button>,
        ]}
      >
        <Table
          dataSource={modifyConfig || []}
          rowKey={(record) => record.id}
          columns={actionsHistoryColumns}
          pagination={false}
          size="small"
        />
      </Modal>
      <Button
        type="link"
        shape="circle"
        icon={<HistoryOutlined />}
        onClick={() => {
          setHandleVisibleHistory((oldVisible) => !oldVisible);
        }}
      />
    </>
  ) : (
    <></>
  );
};

export default FieldValueHistoryModal;
